import { Modal } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next';

const NoAnyDocs = ({showNoDocsError, handleCloseErrorModal}) => {
  const { t } = useTranslation();
  return (
    <Modal
        className="custom-modal responsiveModal text-center"
        open={showNoDocsError}
        onCancel={handleCloseErrorModal}
        footer={null}
        closeIcon={null}
        centered
        maskClosable={false}
        maskStyle={{
          backdropFilter: 'blur(8px)',
          WebkitBackdropFilter: 'blur(8px)',
        }}
      >
        <div className="gb fs-20 text-center mb-40">
          {t("The requested agreement document has been deactivated by the administrator.")}
        </div>

        <div className="text-center">
          <button
            className="saveBtn cursor-pointer w-117"
            onClick={handleCloseErrorModal}
          >
            {t("Okay")}
          </button>
        </div>
      </Modal>
  )
}

export default NoAnyDocs
